import { render, staticRenderFns } from "./BaseInformationalDocument.vue?vue&type=template&id=9dac4774"
import script from "./BaseInformationalDocument.vue?vue&type=script&lang=js"
export * from "./BaseInformationalDocument.vue?vue&type=script&lang=js"
import style0 from "./BaseInformationalDocument.vue?vue&type=style&index=0&id=9dac4774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports